import { render, staticRenderFns } from "./AkbankForm.vue?vue&type=template&id=f977c634"
import script from "./AkbankForm.vue?vue&type=script&lang=js"
export * from "./AkbankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports